import { NgModule } from '@angular/core';
import {ProductNamePipe} from './product-name.pipe';

@NgModule({
  declarations: [ProductNamePipe],
  exports: [
    ProductNamePipe
  ]
})
export class ProductNamePipeModule { }
